<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import './App.scss';

export default {
  name: 'App',
};
</script>
